import React from 'react';
import PropTypes from 'prop-types';

/**
 * Asks for confirmation before generating a print job with a lot of sheets.
 * `hide` is injected by the UIModalService provider.
 */
const PrintConfirmDialog = ({ message, hide, onConfirm }) => (
  <div className="PrintConfirmDialog">
    <p>{message}</p>
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
      <button type="button" className="btn btn-danger" onClick={hide}>
        Cancelar
      </button>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => {
          hide();
          onConfirm();
        }}
      >
        Imprimir
      </button>
    </div>
  </div>
);

PrintConfirmDialog.propTypes = {
  message: PropTypes.string.isRequired,
  hide: PropTypes.func,
  onConfirm: PropTypes.func.isRequired,
};

export default PrintConfirmDialog;
